
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  BusinessSectorResponse,
} from '../models';
import {
    BusinessSectorResponseFromJSON,
    BusinessSectorResponseToJSON,
} from '../models';

/**
 * 
 */
export class BusinessSectorsApi extends runtime.BaseAPI {

    /**
     * Find all business sectors
          */
    async findAllBusinessSectorsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<BusinessSectorResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<BusinessSectorResponse>>({
            path: `/search/api/business-sectors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(BusinessSectorResponseFromJSON);
        return response;
    }

    /**
     * Find all business sectors
          */
    async findAllBusinessSectors(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<BusinessSectorResponse>> {
        const response = await this.findAllBusinessSectorsRaw(initOverrides);
        return response._data;
    }

}
